import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'tf0034',
    ecrans: ['00-2']
});
